import { ImoClass } from '../graphql';

export const imoClassPairs: Array<[ImoClass, string]> = [
  [ImoClass.NON_HAZARDOUS, 'Non hazardous'],
  [ImoClass.CLASS_1_EXPLOSIVES, 'Class 1 Explosives'],
  [
    ImoClass._1_1_OBJECTS_WITH_MASS_EXPLOSION_HAZARD,
    '1.1 Objects with mass explosion hazard',
  ],
  [
    ImoClass._1_2_OBJECTS_WITH_PROJECTION_HAZARD_BUT_NO_MASS_EXPLOSION,
    '1.2 Objects with projection hazard but no mass explosion',
  ],
  [
    ImoClass._1_3_OBJECTS_WITH_FIRE_HAZARD_AND_A_MINOR_BLAST_HAZARD,
    '1.3 Objects with fire hazard and a minor blast hazard',
  ],
  [
    ImoClass._1_4_EXPLOSIVES_THAT_DO_NOT_PRESENT_A_SIGNIFICANT_HAZARD,
    '1.4 Explosives that do not present a significant hazard',
  ],
  [
    ImoClass._1_5_INSENSITIVE_SUBSTANCES_WITH_MASS_EXPLOSION_HAZARD,
    '1.5 Insensitive substances with mass explosion hazard',
  ],
  [
    ImoClass._1_6_EXTREMELY_INSENSITIVE_ARTICLES_NO_MASS_EXPLOSION_HAZARD,
    '1.6 Extremely insensitive articles, no mass explosion hazard',
  ],
  [ImoClass._2_1_FLAMMABLE_GASES, '2.1 Flammable gases'],
  [ImoClass._2_2_NON_FLAMMABLE_GASES, '2.2 Non-Flammable gases'],
  [ImoClass._2_3_TOXIC_GASES, '2.3 Toxic gases'],
  [ImoClass.CLASS_3_FLAMMABLE_LIQUIDS, 'Class 3 Flammable Liquids'],
  [
    ImoClass.CLASS_4_FLAMMABLE_SOLIDS_OR_SUBSTANCES,
    'Class 4 Flammable Solids or Substances',
  ],
  [ImoClass._4_1_FLAMMABLE_SOLIDS, '4.1 Flammable solids'],
  [
    ImoClass._4_2_SUBSTANCES_LIABLE_TO_SPONTANEOUS_COMBUSTION,
    '4.2 Substances liable to spontaneous combustion',
  ],
  [
    ImoClass._4_3_SUBSTANCES_THAT_EMIT_FLAMMABLE_GASES,
    '4.3 Substances that emit flammable gases',
  ],
  [
    ImoClass.CLASS_5_OXIDIZING_SUBSTANCES_AND_ORGANIC_PEROXIDES,
    'Class 5 Oxidizing Substances and Organic Peroxides',
  ],
  [ImoClass._5_1_OXIDIZING_SUBSTANCES, '5.1 Oxidizing substances'],
  [ImoClass._5_2_ORGANIC_PEROXIDES, '5.2 Organic peroxides'],
  [
    ImoClass.CLASS_6_TOXIC_AND_INFECTIOUS_SUBSTANCES,
    'Class 6 Toxic and infectious Substances',
  ],
  [ImoClass._6_1_TOXIC_SUBSTANCES, '6.1 Toxic substances'],
  [ImoClass._6_2_INFECTIOUS_SUBSTANCES, '6.2 Infectious substances'],
  [ImoClass.CLASS_7_RADIOACTIVE_SUBSTANCES, 'Class 7 Radioactive Substances'],
  [ImoClass.CLASS_8_CORROSIVES, 'Class 8 Corrosives'],
  [
    ImoClass.CLASS_9_MISCELLANEOUS_DANGEROUS_SUBSTANCES_AND_ARTICLES,
    'Class 9 Miscellaneous dangerous substances and articles',
  ],
  [
    ImoClass.MHB_MATERIALS_HAZARDOUS_ONLY_IN_BULK,
    'MHB Materials hazardous only in bulk',
  ],
];

export const imoClassNames = imoClassPairs.map(([, name]) => name);

export const imoClasses: Array<{
  name: string;
  value: string;
}> = imoClassPairs.map(([key, name]) => {
  return { name, value: key };
});

export const imoClassOptions = imoClasses.map((imoClass) => ({
  id: imoClass.value,
  label: imoClass.name,
}));

export const imoClassByLabel = imoClassPairs.reduce<Record<string, ImoClass>>(
  (acc, [imoClass, label]) => ({ ...acc, [label]: imoClass }),
  {},
);
